import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/governance-runtime/page.tsx");
